'use client'

import { CarouselBlock as CarouselBlockType } from '@/payload-types'

const carousel = {
  products: null,
  brands: null,
  testimonials: null,
}

const CarouselBlock: React.FC<CarouselBlockType> = (props) => {
  const { type } = props || {}

  if (!type) return null

  const CarouselToRender = carousel[type]

  if (!CarouselToRender) return null

  // return <CarouselToRender {...props} />
  return null
}

export default CarouselBlock
